export default __webpack_public_path__ + "static/media/gallery_03.cf7ce11a.jpg";